/* 今日呼出离线支持：清单本地缓存 + 结果离线队列（联网后按顺序回放，保留原始拨打时间） */
const K = (u, k) => `tm_${k}_${u}`;

export const isNetworkError = (e) => !!e && !e.response;
export const online = () => (typeof navigator === "undefined" ? true : navigator.onLine !== false);

export const cacheToday = (u, data) => { try { localStorage.setItem(K(u, "today"), JSON.stringify({ at: new Date().toISOString(), data })); } catch { /* quota */ } };
export const readTodayCache = (u) => { try { return JSON.parse(localStorage.getItem(K(u, "today")) || "null"); } catch { return null; } };

export const readQueue = (u) => { try { return JSON.parse(localStorage.getItem(K(u, "queue")) || "[]"); } catch { return []; } };
const writeQueue = (u, q) => localStorage.setItem(K(u, "queue"), JSON.stringify(q));
export const enqueueOutcome = (u, entry) => { const q = readQueue(u); q.push({ ...entry, queuedAt: new Date().toISOString() }); writeQueue(u, q); return q.length; };

/* 依次回放；遇网络错误保留当前及之后的条目，业务错误（如该项已处理）丢弃并上报 */
export async function flushQueue(api, u, onEvent) {
  const q = readQueue(u);
  if (!q.length) return { synced: 0, remain: 0, dropped: 0 };
  const remain = [];
  let dropped = 0;
  for (let i = 0; i < q.length; i++) {
    const e = q[i];
    try {
      const { data } = await api.post(`/tm/today/${e.itemId}/outcome`, { ...e.body, queuedAt: e.queuedAt, dialMode: "manual" });
      onEvent?.({ type: "synced", entry: e, data });
    } catch (err) {
      if (isNetworkError(err)) { remain.push(...q.slice(i)); break; }
      dropped += 1;
      onEvent?.({ type: "dropped", entry: e, detail: err?.response?.data?.detail });
    }
  }
  writeQueue(u, remain);
  return { synced: q.length - remain.length - dropped, remain: remain.length, dropped };
}

/* 本地乐观更新：把当前项移到已完成，并返回下一条待拨 */
export const applyLocalOutcome = (d, item, label) => {
  if (!d) return { d, next: null };
  const done = { ...item, status: "done", outcomeLabel: label, completedAt: new Date().toISOString(), offlinePending: true };
  const items = (d.items || []).filter((i) => i.id !== item.id);
  const stats = { ...(d.stats || {}), todo: Math.max(0, (d.stats?.todo || 1) - 1), calls: (d.stats?.calls || 0) + 1 };
  return { d: { ...d, items, done: [done, ...(d.done || [])], stats }, next: items.find((i) => i.status !== "done") || null };
};
